"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureCode = exports.BundleStatus = exports.BundlePricing = exports.BundleItemType = void 0;
var BundleItemType;
(function (BundleItemType) {
    BundleItemType["PROGRAM"] = "program";
    BundleItemType["FEATURE"] = "feature";
})(BundleItemType || (exports.BundleItemType = BundleItemType = {}));
var BundlePricing;
(function (BundlePricing) {
    BundlePricing["OTP"] = "otp";
    BundlePricing["SUBSCRIPTION"] = "subscription";
})(BundlePricing || (exports.BundlePricing = BundlePricing = {}));
var BundleStatus;
(function (BundleStatus) {
    BundleStatus["DRAFT"] = "draft";
    BundleStatus["PUBLISHED"] = "published";
    BundleStatus["ARCHIVED"] = "archived";
})(BundleStatus || (exports.BundleStatus = BundleStatus = {}));
var FeatureCode;
(function (FeatureCode) {
    FeatureCode["DM"] = "dm";
    FeatureCode["COMMUNITY"] = "community";
    FeatureCode["LIVESTREAM"] = "livestream";
    FeatureCode["INSIGHT"] = "insight";
    FeatureCode["STORY"] = "story";
    FeatureCode["NUTRITION"] = "nutrition";
})(FeatureCode || (exports.FeatureCode = FeatureCode = {}));
